module.exports = __webpack_public_path__ + "img/icon-error-octagon-ani.4eb28704.svg";